import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { RbacService } from '@core/services/rbac.service';
import { pageUrls } from 'src/app/configuration/pages';

/**
 * Route guard that checks RBAC permissions.
 * Usage in routes: canActivate: [authGuard, roleGuard('users', ['GET'])]
 *
 * @param subject - The permission subject (e.g. 'users', 'items', 'roles')
 * @param methods - HTTP methods the user must have at least one of (default: ['GET'])
 */
export const roleGuard = (subject: string, methods: string[] = ['GET']) => () => {
  const rbacService = inject(RbacService);
  const router = inject(Router);

  if (rbacService.canAny(subject, methods)) {
    return true;
  }

  const fallback = rbacService.getFirstAccessiblePage();
  return router.createUrlTree([`/${fallback}`]);
};

